import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChartFillingGoal = ({ selectedMonth, selectedYear }) => {
  const [filled, setFilled] = useState(0);
  const [goal, setGoal] = useState(200); // You can fetch or make this dynamic if needed

const fetchFilled = async () => {
  try {
    const res = await fetch(`/api/fillings/count-summary?range=month&month=${selectedMonth}&year=${selectedYear}`);
    const data = await res.json();
    setFilled(data.count || 0);
  } catch (err) {
    console.error('❌ Error fetching monthly filled cylinders:', err);
  }
};


  useEffect(() => {
    fetchFilled();
    const interval = setInterval(fetchFilled, 10000);
    return () => clearInterval(interval);
  }, []);

  const percentage = ((filled / goal) * 100).toFixed(1);

  const data = {
    labels: ['Llenados', 'Restante'],
    datasets: [
      {
        data: [filled, Math.max(goal - filled, 0)],
        backgroundColor: ['#009688', '#e0e0e0'],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    cutout: '70%',
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    maintainAspectRatio: false,
  };

  return (
    <div
      style={{
        height: '100%',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ width: '100%', height: '110px' }}>
        <Doughnut data={data} options={options} />
      </div>
      <div
        style={{
          textAlign: 'center',
          marginTop: '5px',
          fontSize: '1.2rem',
          fontWeight: 'bold',
        }}
      >
        {percentage}% <br />
        <span style={{ fontSize: '0.85rem', fontWeight: 'normal' }}>de la meta</span>
      </div>
    </div>
  );
};

export default PieChartFillingGoal;
